import { Popover as MuiPopover } from '@material-ui/core';
import { makeStyles } from 'makeStyles';
import styled from 'styled-components';

export const usePopoverClasses = makeStyles()(theme => ({
  listbox: {
    fontSize: '0.75rem',
    color: theme.splitcPalette.neutral[4],
    fontWeight: 500,
  },
  autoCompletePaper: {
    boxShadow: 'none',
  },
}));

export const FilterPopover = styled(MuiPopover)`
  .MuiTypography-root {
    font-size: 0.75rem;
    font-weight: 500;
    color: ${({ theme }) => theme.splitcPalette.neutral[4]};
  }

  .MuiAutocomplete-option {
    white-space: pre;
  }

  .MuiAutocomplete-popperDisablePortal {
    position: relative !important;
  }
`;
